import { PUBLIC_EVENT_KEY } from '../constants';
import { PublicEvent } from '../enums';
import { PublicEventPayloadByEvent } from '../types';

export const sendPublicEvent = <Event extends PublicEvent>(
  event: Event,
  payload: PublicEventPayloadByEvent[Event]
) => {
  window.dispatchEvent(
    new CustomEvent(`${PUBLIC_EVENT_KEY}.${event}`, { detail: payload })
  );
};
